import { ReactNode } from 'react';
import { PaymentMethod } from '@mews-commander/data-access';
import { Link } from '@optimus-web/core';
import { DataTestId } from '@mews-commander/enums';
import { useToggle } from '@mews/framework';
import { WithAccountId } from '@mews-commander/types';
import { PaymentMethodDetails } from '../../sidePanels/PaymentMethodDetailSidebar/PaymentMethodDetails';

interface Props extends WithAccountId {
    paymentMethodId: string;
    paymentMethod: PaymentMethod;
    sidebarTitle: ReactNode;
    linkTitle: ReactNode;
}

export const PaymentMethodSidebarLink = ({
    paymentMethodId,
    accountId,
    paymentMethod,
    sidebarTitle,
    linkTitle,
}: Props) => {
    const [opened, toggleOpened] = useToggle();
    return (
        <>
            <Link inherit onClick={toggleOpened} data-test-id={DataTestId.PaymentMethodLink}>
                {linkTitle}
            </Link>
            {opened && (
                <PaymentMethodDetails
                    isOpen={opened}
                    closeDialog={toggleOpened}
                    paymentCardId={paymentMethodId}
                    accountId={accountId}
                    paymentMethodType={paymentMethod}
                    title={sidebarTitle}
                />
            )}
        </>
    );
};
